import { render } from "./MemberRedemptionButton.vue?vue&type=template&id=00691864"
import script from "./MemberRedemptionButton.vue?vue&type=script&lang=js"
export * from "./MemberRedemptionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__